<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    titleParagraph: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="customer-compliance-report-item d-flex flex-column i-gap-3">
    <div
      :class="{
        'i-text-heading-4': titleParagraph,
        'i-text-heading-6': !titleParagraph,
      }"
      class="title i-text-neutral-120"
    >
      {{ title }}
    </div>
    <div class="text i-text-neutral-120 i-text-body-2">{{ text }}</div>
  </div>
</template>

<style lang="scss" scoped>
.customer-compliance-report-item {
}
</style>
